import { render } from "./cash.vue?vue&type=template&id=4ef2c35e&scoped=true"
import script from "./cash.vue?vue&type=script&lang=js"
export * from "./cash.vue?vue&type=script&lang=js"

import "./cash.vue?vue&type=style&index=0&id=4ef2c35e&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef2c35e"]])

export default __exports__